const ReportScreen = () => {
  const template = <></>

  return template
}

export default ReportScreen